import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { RoleTemplatesWorkspace } from './RoleTemplatesPage';

/** ADMIN-05 — one role template, between the library and what a recruiter gets (Role templates A). `new` opens an empty one. */
export function RoleTemplateEditorPage(): ReactNode {
  const { templateId } = useParams({ from: '/app-layout/admin/role-templates/$templateId' });
  return <RoleTemplatesWorkspace selectedId={templateId} />;
}
